module.exports = __webpack_public_path__ + "img/logo_SHiG.8685eb06.png";